import { BrowserRouter as Router } from 'react-router-dom';
import { CartProvider } from 'react-use-cart';
import { AuthProvider } from './Hooks/authProvider';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './Components/ErrorBoundary';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Fonts/Montserrat-Regular.ttf'
import './Fonts/Montserrat-Medium.ttf'
import './Fonts/Montserrat-Bold.ttf'

const container = document.getElementById("root")

const root = createRoot(container)

root.render(
  <React.StrictMode>
    <Router>
    <AuthProvider>
        <CartProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </CartProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
)
